import { defineAsyncComponent } from "vue";

export const LINII_COMPONENTS_MAP: Record<string, ReturnType<typeof defineAsyncComponent>> = {
    'Contabilitate': defineAsyncComponent(() => import('./LiniiContabilitate.vue')),
    'Facturi furnizor': defineAsyncComponent(() => import('./LiniiFacturiFurnizor.vue')),
    'Facturi client': defineAsyncComponent(() => import('./LiniiFacturiClient.vue')),
    'Personal - Salarizare': defineAsyncComponent(() => import('./LiniiPersonalSalarizare.vue')),
    'Documente Aferente Contractelor': defineAsyncComponent(() => import('./LiniiDocumenteAferenteContractelor.vue')),
    'Mijloace fixe': defineAsyncComponent(() => import('./LiniiMijloaceFixe.vue')),
    'Documente productie': defineAsyncComponent(() => import('./LiniiDocumenteProductie.vue')),
    'Documente Financiare': defineAsyncComponent(() => import('./LiniiDocumenteFinanciare.vue')),
    'Solduri Initiale': defineAsyncComponent(() => import('./LiniiSolduriInitiale.vue')),
    'Documente gestiune': defineAsyncComponent(() => import('./LiniiDocumenteGestiune.vue'))
};